import React from "react";
import PropTypes from "prop-types";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Polygon
} from "react-google-maps";

const ScooterZonesMap = props => {
  const { places } = props;

  return (
    <GoogleMap
      defaultZoom={9}
      defaultCenter={{
        lat: 40.15,
        lng: 44.51
      }}
    >
      {places.map(place =>
        place.featureCollection.features.map(feature => feature.geometry.coordinates.map((coordinates, coordinatesIndex) =>
          <Polygon key={coordinatesIndex} path={coordinates.map(coordinate => ({
            lat: coordinate[1],
            lng: coordinate[0]
          }))}/>)))}
    </GoogleMap>
  );
};

ScooterZonesMap.propTypes = {
  places: PropTypes.array,
};

export default withScriptjs(withGoogleMap(ScooterZonesMap));



// WEBPACK FOOTER //
// ./src/views/pages/scooter/zones/map.js